// src/services/profileService.js
import { supabase } from '../supabaseClient';

/**
 * Incrémenter le compteur de matchs pour un utilisateur gratuit
 * À appeler après la création d'un nouveau match
 */
export const incrementMatchCount = async (userId) => {
  try {
    // Récupérer le profil actuel
    const { data: profile, error: fetchError } = await supabase
      .from('profiles')
      .select('role, matches_count')
      .eq('id', userId)
      .single();
    
    if (fetchError) {
      console.error('Erreur récupération profil:', fetchError);
      return { success: false, error: fetchError };
    }
    
    // Incrémenter seulement pour les utilisateurs gratuits
    if (profile.role === 'gratuit') {
      const { error: updateError } = await supabase
        .from('profiles')
        .update({ 
          matches_count: (profile.matches_count || 0) + 1 
        })
        .eq('id', userId);
      
      if (updateError) {
        console.error('Erreur incrémentation:', updateError);
        return { success: false, error: updateError };
      }
      
      console.log(`✅ Compteur incrémenté: ${profile.matches_count + 1}`);
    }
    
    return { success: true };
  } catch (error) {
    console.error('Erreur incrementMatchCount:', error);
    return { success: false, error };
  }
};

/**
 * Démarrer un essai gratuit (Normal ou Expert)
 */
export const startTrial = async (userId, targetRole) => {
  if (!['normal', 'expert'].includes(targetRole)) {
    return { success: false, error: 'Rôle invalide' };
  }
  
  const trialDuration = targetRole === 'expert' ? 14 : 7; // 14j pour expert, 7j pour normal
  
  const trialEndsAt = new Date();
  trialEndsAt.setDate(trialEndsAt.getDate() + trialDuration);
  
  try {
    const { error } = await supabase
      .from('profiles')
      .update({
        role: targetRole,
        subscription_status: 'trial',
        trial_started_at: new Date().toISOString(),
        trial_ends_at: trialEndsAt.toISOString()
      })
      .eq('id', userId);
    
    if (error) {
      console.error('Erreur démarrage essai:', error);
      return { success: false, error };
    }
    
    console.log(`✅ Essai ${targetRole.toUpperCase()} démarré (${trialDuration} jours)`);
    return { success: true };
  } catch (error) {
    console.error('Erreur startTrial:', error);
    return { success: false, error };
  }
};

/**
 * Activer un abonnement payant
 */
export const activateSubscription = async (userId, role, durationMonths = 1) => {
  if (!['normal', 'expert'].includes(role)) {
    return { success: false, error: 'Rôle invalide' };
  }
  
  const subscriptionEndsAt = new Date();
  subscriptionEndsAt.setMonth(subscriptionEndsAt.getMonth() + durationMonths);
  
  try {
    const { error } = await supabase
      .from('profiles')
      .update({
        role: role,
        subscription_status: 'active',
        subscription_started_at: new Date().toISOString(),
        subscription_ends_at: subscriptionEndsAt.toISOString()
      })
      .eq('id', userId);
    
    if (error) {
      console.error('Erreur activation abonnement:', error);
      return { success: false, error };
    }
    
    console.log(`✅ Abonnement ${role.toUpperCase()} activé (${durationMonths} mois)`);
    return { success: true };
  } catch (error) {
    console.error('Erreur activateSubscription:', error);
    return { success: false, error };
  }
};

/**
 * Rétrograder vers gratuit (fin essai ou abonnement expiré)
 */
export const downgradeToFree = async (userId) => {
  try {
    const { error } = await supabase
      .from('profiles')
      .update({
        role: 'gratuit',
        subscription_status: 'expired'
      })
      .eq('id', userId);
    
    if (error) {
      console.error('Erreur rétrogradation:', error);
      return { success: false, error };
    }
    
    console.log('✅ Compte rétrogradé vers gratuit');
    return { success: true };
  } catch (error) {
    console.error('Erreur downgradeToFree:', error);
    return { success: false, error };
  }
};